import {
  GET_OPERATOR_DATA,
  GET_OPERATOR_DATA_SUCCESS,
  GET_OPERATOR_DATA_FAIL,
  GET_ALL_OPERATOR_DATA,
  GET_ALL_OPERATOR_DATA_SUCCESS,
  GET_ALL_OPERATOR_DATA_FAIL
} from '../constants/operator';

const initialState = {
  loading: false,
  loaded: false,
  data: [],
  allData: [],
  error: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_OPERATOR_DATA:
      return {
        ...state,
        loading: true,
        loaded: false,
        data: [],
        error: null
      };
    case GET_OPERATOR_DATA_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: [],
        error: action.error
      };
    case GET_OPERATOR_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.data,
        error: null
      };
    case GET_ALL_OPERATOR_DATA:
      return {
        ...state,
        loading: true,
        loaded: false,
        allData: [],
        error: null
      };
    case GET_ALL_OPERATOR_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        allData: action.data,
        error: null
      };
    case GET_ALL_OPERATOR_DATA_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        allData: [],
        error: action.error
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/operator.js